export type ChecklistAssignableUser = {
    readonly id: string;
    readonly email: string;
    readonly first_name?: string | null;
    readonly last_name?: string | null;
};

export function getChecklistUserOptions<T extends ChecklistAssignableUser>(
    assignableUsers: Array<T>,
    assignedUser: T | null | undefined,
): Array<T> {
    if (
        assignedUser === null ||
        assignedUser === undefined ||
        assignableUsers.some((user) => user.id === assignedUser.id)
    ) {
        return assignableUsers;
    }

    return [assignedUser, ...assignableUsers];
}

export function formatChecklistUser(user: ChecklistAssignableUser): string {
    const fullName = `${user.first_name ?? ''} ${user.last_name ?? ''}`.trim();
    if (fullName && user.email) {
        return `${fullName} (${user.email})`;
    }
    return fullName || user.email;
}
